<template>
  <div id="LoginForm">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{$t('Вход в систему')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn icon large href="https://www.alseco.kz" target="_blank" v-on="on">
              <v-icon large>mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Помощь')}}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="doLogin()">
          <v-text-field
            prepend-icon="mdi-account"
            name="login"
            :label="$t('Логин')"
            type="text"
            autocomplete="username"
            v-model="loginData.userLogin"
          ></v-text-field>
          <v-text-field
            id="password"
            prepend-icon="mdi-lock"
            name="password"
            :label="$t('Пароль')"
            type="password"
            autocomplete="current-password"
            v-model="loginData.userPassword"
          ></v-text-field>
          <v-progress-circular v-if="showProgress" indeterminate color="primary"></v-progress-circular>
          <h2>{{authResult}}</h2>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">{{$t('Вход')}}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/*
Форма авторизации.
Входные параметры:
authResult - для отслеживания результата авторизации пользователя
showProgress - для отслеживания хода выполнения процесса авторизации

Форма авторизации иницирует событие submitlogin по клику на кнопку "Вход".
Значения формы передаются через парамтеры события: { login: логин, passwod: парль}.
*/

export default {
    name: 'LoginForm',
    props: {
        authResult: {
            type: String,
            default: ''
        },
        showProgress: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({ loginData: { userLogin: '', userPassword: '' } }),

    computed: {},
    methods: {
        async doLogin() {
            try {
                this.$emit('submitlogin', { login: this.loginData.userLogin, password: this.loginData.userPassword });
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>